import React from "react";
import xplanLabels from "../../util/XplanLabels";
import { Grid, Typography } from "@mui/material";

const LegacyPullList = ({ legacyPullListLink, legacyMigratedPullList, pullListFolderId }) => {
    const labelStyle = { width: "200px", display: "inline-block", marginRight: "8px", fontWeight: "bold" };

    return (
        <>
            {legacyMigratedPullList &&
                <Grid container id="legacyMigratedPullList">
                    <Grid item xs="auto">
                        <Typography style={labelStyle}>
                            {xplanLabels.legacyMigratedPullList}:
                        </Typography>
                    </Grid>
                    <Grid item xs>
                        <Typography whiteSpace="pre-wrap" style={{ marginLeft: "32px" }}>
                            <a
                                href={`https://bri.app.box.com/folder/${pullListFolderId}`}
                                target="_blank"
                                rel="noopener noreferrer">
                                {`https://bri.app.box.com/folder/${pullListFolderId}`}
                            </a>
                        </Typography>
                    </Grid>
                </Grid>
            }
            {legacyPullListLink &&
                <Grid container id="legacyPullListLink">
                    <Grid item xs="auto">
                        <Typography style={labelStyle}>
                            {xplanLabels.legacyPullListLink}:
                        </Typography>
                    </Grid>
                    <Grid item xs>
                        <Typography whiteSpace="pre-wrap" style={{ marginLeft: "32px" }}>
                            <a
                                href={legacyPullListLink}
                                target="_blank"
                                rel="noopener noreferrer">
                                {legacyPullListLink}
                            </a>
                        </Typography>
                    </Grid>
                </Grid>
            }
        </>
    );
};

export default LegacyPullList;